/*
 * @Author: your name
 * @Date: 2021-10-08 10:50:04
 * @LastEditTime: 2021-10-14 11:45:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \LPKJ.WCN.YTH.NFP.PC.UI\src\api\config.js
 */
export default {
    // baseUrl: "http://nettransport.yyth.com.cn/api", // 正式环境地址
    baseUrl: "https://nfpapi.yyth.com.cn", // 正式环境地址SSL
    // baseUrl: "http://220.163.124.222:10007",
    // baseUrl: "http://10.5.5.145:8081",
    // ws:"http://220.163.124.222:10007",
    ws:"https://nfpapi.yyth.com.cn",
    // ws:"http://nettransport.yyth.com.cn/api",
    // ws:"http://10.5.5.79:8081",
    // ws:"http://127.0.0.1:8081",
    K:"TwlBseKCPSnuASsi",
    N:"luCvK4670w5LplC0"
}
